import React from 'react';
import { Helmet } from 'react-helmet';
import { SITE } from '../seo/site';
import { routeMeta } from '../seo/routes';

const Seo = ({
  path,
  title,
  description,
  jsonLd,
  noindex = false,
}) => {
  const meta = routeMeta(path || '/');
  const pageTitle = title || meta.title;
  const pageDescription = description || meta.description;
  const canonical =
    !path || path === '/' ? `${SITE}/` : `${SITE}${path}`;
  const blocks = jsonLd
    ? Array.isArray(jsonLd)
      ? jsonLd
      : [jsonLd]
    : [];

  return (
    <Helmet>
      <html lang="en-GB" />
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <link rel="canonical" href={canonical} />
      <meta
        name="robots"
        content={
          noindex
            ? 'noindex, follow'
            : 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1'
        }
      />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={`${SITE}/images/hero-construction.jpg`} />
      <meta property="og:locale" content="en_GB" />
      <meta property="og:site_name" content="Fallow Building Services" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={`${SITE}/images/hero-construction.jpg`} />
      {blocks.map((block, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(block)}
        </script>
      ))}
    </Helmet>
  );
};

export default Seo;
